module.exports = __webpack_public_path__ + "static/media/user-agent-dark.03fc80b5.svg";